import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {ResizeEvent} from "angular-resizable-element";
import {GuideForm} from "../../../../../models/guide-form";
import { FormioControllerService } from "../../../../../services/form-controller/formio-controller.service";
import {GuideFormControllerService} from "../../../../../services/form-controller/guide-form-controller.service";
import FormUtils from "../../../../utils/form-utils.component";
import {Store} from "../../../../../services/store.service";
import {BaseError} from "../../../base-error";
import {ToastrService} from "ngx-toastr";
import { environment } from "../../../../../../environments/environment";
import Helpers from "../../../../../utils/helpers";
import {FormControllerService} from "../../../../../services/form-controller/form-controller.service";

@Component({
  selector: "guide-form",
  templateUrl: "./guide-form.component.html",
  providers: [GuideFormControllerService, FormioControllerService],
})

export class GuideFormComponent extends BaseError implements OnInit {

  public serviceId: string;
  public activeTab: string = "form";
  // public guideForm: GuideForm = new GuideForm();
  @Input() public determinantMapById: { [key: string]: string };
  @Input() public guideForm: GuideForm = new GuideForm();
  @Input() public focusCompKey?: string;
  @Output() public formReverted: EventEmitter<GuideForm> = new EventEmitter();
  public style: object = {};
  public showHistory: boolean = false;

  constructor(private route: ActivatedRoute,
              public store: Store,
              public toastr: ToastrService,
              private formControllerService: FormControllerService,
              public guideFormControllerService: GuideFormControllerService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.store.state.common.applicantFormPage.set("guide-form");
      // this.loadForm();
    });
  }

  public notifyTabChange(newtab: string): void {
    this.activeTab = newtab;
  }

  public saveForm(formSchema: any) {
    if (this.guideForm.id) {
      // add version to distinguish old and new form builder components
      if (formSchema && formSchema.components) {
        for (const comp of formSchema.components) {
          FormUtils.updateWithVersion(comp);
          FormUtils.updateTableAttributes(comp);
        }
      }
    }
    this.guideForm.formSchema = formSchema;
    if (this.guideForm.id) {
      this.guideFormControllerService.saveGuideForm(this.guideForm).subscribe(
          () => undefined,
          (error) => this.showErrorMessage(error),
      );
    } else {
      this.guideFormControllerService.createGuideForm(this.serviceId, this.guideForm).subscribe(
        (data) => {
          this.guideForm = (data ? data : this.guideForm);
        },
      );
    }
  }

  public saveTutorial(e) {
    if (e) {
      this.guideForm.tutorials.general = e;
      this.saveForm(this.guideForm.formSchema);
    }
  }

  public activateForm() {
    this.guideFormControllerService.activateGuideForm(this.guideForm.id, this.guideForm.active).subscribe();
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

  public openHistory() {
    this.showHistory = true;
  }

  public closeHistory() {
    this.showHistory = false;
  }

  public changeForm(revisionNumber: string): void {
    if (revisionNumber) {
      // Step 1: GET the schema for validation
      this.guideFormControllerService.getFormSchemaForRevision(this.serviceId, revisionNumber).subscribe((schema) => {
        if (schema) {
          // Step 2: Validate schema for duplicate keys
          const result = Helpers.validateFormSchema(schema);
          if (Array.isArray(result) && result.length > 0) {
            this.error("Please reload page!\n" + Helpers.generateValidationErrorMessages(result).join("\n"), 'Validation error');
          }
          else {
            // Step 3: If valid, call PUT to revert (triggers cleanup of orphaned relations)
            this.guideFormControllerService.revertFormToRevision(this.serviceId, revisionNumber).subscribe(
              () => {
                // Step 4: Reload the form after successful reversion
                this.guideFormControllerService.getGuideForm(this.serviceId, false).subscribe(
                  (data) => {
                    this.guideForm = data ? data : this.guideForm;
                    this.formReverted.emit(this.guideForm);
                    this.responseSuccessful("Form reverted successfully");
                  },
                  (error) => this.showErrorMessage(error)
                );
              },
              (error) => this.showErrorMessage(error)
            );
          }
        }
      });
    }
  }

  public downloadSchema() {
    this.formControllerService.downloadSchemaWithRelations(this.guideForm.id).subscribe(
      (data) => {
        const blob = new Blob([data], { type: "application/octet-stream" });
        const downloadURL = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = downloadURL;
        link.download = `${this.store.state.common.serviceName}_guide_form_schema.json`;
        link.click();
      },
      (error) => this.showErrorMessage(error),
    );
  }
}
